<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Episode Claim
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-10">
            <div class="col-10">
              <div v-if="claim.controlNumber"><span class="confirm-label mb-2">Control Number: </span>
                <span class="confirm-text"> {{ claim.controlNumber }}<br><br></span></div>
              <div v-if="claim.correlationId"><span class="confirm-label">Correlation ID: </span>
                <span class="confirm-text">{{ claim.correlationId }}<br><br></span></div>
              <div v-if="claim.createdAt"><span class="confirm-label" >Created At: </span>
                <span class="confirm-text">{{ formatDateTime(claim.createdAt) }}<br><br></span></div>
              <div v-if="claim.requestFilePath"><span class="confirm-label" >Request File Path: </span>
                <span class="confirm-text">{{ claim.requestFilePath }}<br><br></span></div>
                <div v-if="claim.responseFilePath"><span class="confirm-label" >Response File Path: </span>
                  <span class="confirm-text">{{ claim.responseFilePath }}<br><br></span></div>
                  <div v-if="claim.rhClaimNumber"><span class="confirm-label" >RH Claim Number: </span>
                    <span class="confirm-text">{{ claim.rhClaimNumber }}<br><br></span></div>
              <div v-if="claim.status"><span class="confirm-label" >Status: </span>
                <span class="confirm-text">{{ claim.status }}<br><br></span></div>
              <div v-if="claim.submittedClaimId"><span class="confirm-label" >Submitted Claim ID: </span>
                <span class="confirm-text">{{ claim.submittedClaimId }}<br><br></span></div>
              <div v-if="claim.traceId"><span class="confirm-label" >Trace ID: </span>
                <span class="confirm-text">{{ claim.traceId }}<br><br></span></div>
              <div v-if="claim.updatedAt"><span class="confirm-label" >Updated At: </span>
                <span class="confirm-text">{{ formatDateTime(claim.updatedAt) }}<br><br></span></div>
                </div>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="submitClaim()">
        Resubmit Claim
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>
<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import moment from 'moment'
  import api from '@/services/api'
  import _ from 'lodash'
  export default {
    name: 'BundleClaimModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      currentClaim: {
        type: Object,
        required: false
      },
      orgPatientEstimateId: {
        type: Number,
        required: false
      }
    },

    data () {
      return {
        claim: {
          controlNumber: '',
          correlationId: '',
          createdAt: '',
          requestFilePath: '',
          responseFilePath: '',
          rhClaimNumber: '',
          status: '',
          submittedClaimId: 0,
          traceId: '',
          updatedAt: ''
        },
        isSaving: false
      }
    },

    watch: {
      visible (newValue) {
        if (newValue) {
          this.claim = _.clone(this.currentClaim)
        }
      }
    },
    methods: {
      submitClaim () {
        if (this.isSaving) {
          return
        }
        this.isSaving = true
        api.post('/Dashboard/SubmitClaim/' + this.orgPatientEstimateId, this.claim).then(response => {
          this.$emit('claimSubmitted', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to submit claim: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      },
      formatDateTime (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY hh:mm a')
        } else {
          return ''
        }
      }
    }

  }

</script>
<style scoped>
.confirm-label {
  font-size: 1rem;
  color: #737284;
  margin-bottom: 1rem;
}

.confirm-text {
  color: #333;
  font-size: 1rem;
}
</style>
